/** Site-wide defaults. Single source of truth for policies shown in copy,
 *  schema.org JSON-LD, and admin defaults. */
export const RETURNS_DAYS_DEFAULT = 14;
export const FREE_SHIPPING_OVER_CENTS_FALLBACK = 9900; // €99